/**
 * IdentityAccess.jsx — Subtab IV
 */

import React from "react";
import { ZeroTrustGate } from "../diagrams.jsx";
import { SubtabHeading, GapBlock, SolutionLead, Body, P } from "../SubtabFrame.jsx";

export default function IdentityAccess() {
  return (
    <article>
      <SubtabHeading roman="IV">Identity, Access, and Authentication</SubtabHeading>
      <ZeroTrustGate />
      <GapBlock>
        Law firms historically manage user access poorly. Departing partners
        retain access for weeks, junior associates get over-scoped permissions,
        and matter-level walls are enforced administratively rather than
        technically.
      </GapBlock>
      <SolutionLead>
        A zero-trust identity architecture borrowed from defense industry
        contractor environments.
      </SolutionLead>
      <Body>
        <P>
          Authentication uses hardware-bound credentials — YubiKey 5 FIPS
          series or equivalent FIPS 140-3 Level 3 tokens issued individually to
          each authorized lawyer. No password-only access, no SMS-based MFA, no
          software tokens. The hardware key is bound to a specific user
          identity through PKI certificate enrollment performed in person at
          engagement initiation, with identity verification meeting NIST SP
          800-63-3 IAL3 standards (the same standard used for PIV cards in
          federal employment).
        </P>
        <P>
          Access is governed by an identity broker — Okta, Ping Identity, or
          Microsoft Entra ID with Privileged Identity Management — configured
          for just-in-time access elevation. Default access is none;
          matter-specific access is granted by the engaging firm's matter
          partner and the CoConsoleX supervising attorney jointly, expires
          automatically at matter close, and is logged immutably.
        </P>
        <P>
          Session security uses certificate-pinned mutual TLS over a dedicated
          VPN tunnel (WireGuard or IPsec with PQ-resistant ciphers where
          available), with continuous device posture verification. Sessions
          terminate automatically on idle and require re-authentication for
          sensitive operations. Browser-based access is prohibited; access uses
          a hardened thick client or VDI session (Citrix or VMware Horizon
          configured to NIAP Common Criteria standards) that prevents
          copy/paste, screen capture, and local file storage.
        </P>
        <P>
          Departure from the engaging firm triggers automatic deprovisioning
          through SCIM integration with the firm's HR system, with the
          supervising attorney notified for confirmation within four business
          hours.
        </P>
      </Body>
    </article>
  );
}
